import { useEffect, useRef } from 'react';

/**
 * Hook that manages Apollo Client polling lifecycle with proper start/stop control.
 * Only calls stopPolling when polling was actually started.
 *
 * @param isPollingEnabled - Whether polling should be enabled
 * @param stopPolling - Apollo Client's stopPolling function
 */
export const usePollingControl = (isPollingEnabled: boolean, stopPolling: () => void) => {
  const wasPollingEnabledRef = useRef(false);

  useEffect(() => {
    if (isPollingEnabled) {
      // Mark that we've enabled polling
      wasPollingEnabledRef.current = true;
    } else if (wasPollingEnabledRef.current) {
      // Only stop polling if we were actually polling before
      stopPolling();
      wasPollingEnabledRef.current = false;
    }
  }, [isPollingEnabled, stopPolling]);
};
